import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, Suspense as _Suspense, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { Text3D } from '@tresjs/cientos';
import { computed } from 'vue'
import type { PropType } from 'vue';
import { Vector3, Vector3Tuple } from "three";

export default /*@__PURE__*/_defineComponent({
  __name: 'SundialLetter',
  props: {
    text: {
        required: true,
        type: String as PropType<string>
    },
    position: {
        required: true,
        type: Object as PropType<Vector3 | Vector3Tuple>,
    },
    castShadow: {
        required: false,
        default: false,
        type: Boolean as PropType<boolean>
    },
    receiveShadow: {
        required: false,
        default: false,
        type: Boolean as PropType<boolean>
    },
    size: {
        required: false,
        default: 0.2,
        type: Number as PropType<number>
    }
},
  setup(__props) {


const props = __props

const visible = computed(() => props.text != '')
const textHeight = computed(() => 0.03 * props.size/0.2)
const rotation = [-Math.PI/2, 0, 0] as [number, number, number]


return (_ctx: any,_cache: any) => {
  const _component_TresMeshPhongMaterial = _resolveComponent("TresMeshPhongMaterial")!
  const _component_TresObject3D = _resolveComponent("TresObject3D")!

  return (_openBlock(), _createBlock(_component_TresObject3D, {
    position: __props.position,
    rotation: rotation,
    visible: visible.value
  }, {
    default: _withCtx(() => [
      (_openBlock(), _createBlock(_Suspense, null, {
        default: _withCtx(() => [
          _createVNode(_unref(Text3D), {
            font: "./fonts/PTSerif_Regular_Only_Numerals.json",
            size: __props.size,
            "bevel-enabled": false,
            height: textHeight.value,
            "cast-shadow": __props.castShadow,
            "receive-shadow": __props.receiveShadow,
            "need-updates": "",
            center: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.text) + " ", 1),
              _createVNode(_component_TresMeshPhongMaterial, { color: "#737373" })
            ]),
            _: 1
          }, 8, ["size", "height", "cast-shadow", "receive-shadow"])
        ]),
        _: 1
      }))
    ]),
    _: 1
  }, 8, ["position", "visible"]))
}
}

})